import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/${string}/modal`;

export const ROUTE: RouteDefinition = `${baseRoute}/:workOrderId/modal`;

export const URL = (workOrderId: number): RouteDefinition => `${baseRoute}/${workOrderId}/modal`;
